<div class="dialog">
  <div class="dialog-box">
    <h2 mat-dialog-title>  {{local_data.title}}  </h2>
  </div>
  <div class="dialog-box-s">
    <div class="dialog-flex mb-5">
      <form [formGroup]="formGroup1">
        <div class="dialog-box dialog-box-m">
          <mat-form-field [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}" class="form-field" appearance="fill">
            <mat-label>{{variables.region}}</mat-label>
            <mat-select formControlName="regionCtrl">
              <mat-option>
                <ngx-mat-select-search formControlName="regionsFilterCtrl" placeholderLabel={{variables.search}} noEntriesFoundLabel={{variables.noProjectFound}}></ngx-mat-select-search>
              </mat-option>
              @for (item of filteredRegions; track item; let i = $index) {
                <mat-option [value]="item.value">
                  <span class="flag-icon flag-icon-{{item.value}}"></span>
                  <span style="margin-left: 6px">{{item.name}}</span>
                </mat-option>
              }
            </mat-select>
            @if (invalidInput) {
              <mat-hint class="error-hint">{{errorMessage}}</mat-hint>
            }
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
  <div class="dialog-box-s">
    <mat-dialog-actions class="button-group">
      <app-button typeBtn="secondary" message="{{variables.goBack}}" mat-dialog-close ></app-button>
      <app-button typeBtn="primary" (click)="doAction()"  message="{{variables.next}}"></app-button>
    </mat-dialog-actions>
  </div>

</div>
